import * as React from 'react'
import { Block, Text } from '$views/components'
import { Icon } from '$views/components/Icon'

const starIcon = require('$icons/star.svg')

interface Props {
  onChange: (rating: number) => void
  label?: string
}

export const ReviewRating: React.SFC<Props> = ({ onChange, label }) => {
  const [rating, setRating] = React.useState<number>(0)

  React.useEffect(() => {
    onChange(rating)
  }, [rating])

  const renderStars = () => {
    let stars = []
    for (let i = 1; i <= 5; i++) {
      if (rating >= i) {
        stars.push(
          <Icon
            key={i}
            content={starIcon}
            color="yellow"
            onClick={() => setRating(i)}
            size="l"
            marginRight="tiny"
            clickable
            testId={label + i}
          />,
        )
      } else {
        stars.push(
          <Icon
            key={i}
            content={starIcon}
            color="lightGrey"
            onClick={() => setRating(i)}
            size="l"
            marginRight="tiny"
            clickable
            testId={label + i}
          />,
        )
      }
    }
    return stars
  }
  return (
    <Block>
      {label && (
        <Text weight="medium" marginBottom="base">
          {label}
        </Text>
      )}
      {renderStars()}
    </Block>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/ReviewRating/ReviewRating.tsx